import { FC } from "react";
import { useLocation } from "react-router-dom";
import { Flex } from "@chakra-ui/react";
import {
  FullBleedSection,
  MaxContentSection,
  BackNavArrowCta,
} from "~/components";
import { useMetaByPathConfig, useStepViewTracker } from "./hooks";
import { Phase } from "./Phase";
import { ProgressBar } from "./ProgressBar";
import { useNav } from "./useNav";

export const Nav: FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { goToPrevious } = useNav();
  const { metaByPath } = useMetaByPathConfig();

  // Nav is the one place every displayed wizard step passes through in BOTH
  // flows: OnboardingLayout renders it for the default flow (AllRoutes) and the
  // partner flow (PartnerOnboardingRoutes), and it sits *inside*
  // OnboardingRedirector, so it mounts only once the redirectors have settled on
  // a step. Emitting from OnboardingLayout instead would record a view for every
  // step a deep link was bounced off of. The call precedes the excludeNav early
  // return so chrome-less steps are still counted.
  useStepViewTracker();

  if (metaByPath[currentPath].excludeNav) {
    return null;
  }

  return (
    <FullBleedSection bg="th.cream1" w="full">
      <MaxContentSection
        align="center"
        h={{ base: "3.625rem", md: 22 }}
        justify="center"
        maxW="160rem"
        overflow="hidden"
        position="relative"
        w="full"
      >
        <Flex
          align="center"
          justify="flex-start"
          left={{ base: 0, md: "1rem" }}
          position="absolute"
          w="full"
        >
          <BackNavArrowCta handleClick={goToPrevious} />
        </Flex>
        <Phase />
      </MaxContentSection>
      <ProgressBar />
    </FullBleedSection>
  );
};
